@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12" novalidate>
    <div class="col-span-12">
      <b>{{ columnName }}:</b>
      {{ columnValidFrom | date: 'dd.MM.yyyy' }} - {{ columnValidTo | date: 'dd.MM.yyyy' }}
    </div>
    <div class="col-span-12">
      <b>{{ rowName }}:</b>
      {{ rowValidFrom | date: 'dd.MM.yyyy' }} - {{ rowValidTo | date: 'dd.MM.yyyy' }}
    </div>
    <app-form-time-period [form]="form" [maxDate]="maxDate" [minDate]="minDate" id="assignments"></app-form-time-period>
    @if (editable) {
      <app-form-button-bar
        (onCancel)="cancel()"
        [form]="form"
        [offset]="false"
        [saveDisabled]="submitting"></app-form-button-bar>
    }
  </form>
}
